<mat-form-field [id]="id" [class]="class" [style]="style" [floatLabel]="floatLabel" data-cy="search-form-field">
  <input (appInputFinished)="onInputFinished($event)" [delayMs]="executionDelay" [disabled]="disabled" matInput type="text" [(ngModel)]="value" (ngModelChange)="onSearchInput($event)" [placeholder]="placeholder" data-cy="search-input">
  <button mat-icon-button *ngIf="isClearable == true && value" matSuffix aria-label="Clear" (click)="onClearSearch()" data-cy="search-clear-button">
    <mat-icon data-cy="search-clear-icon">close</mat-icon>
  </button>
</mat-form-field>
